// export const BaseUrl =" http://localhost:5005"

export const BaseUrl ="https://connect.royalroadtransports.com"


export const appVersion = '1.0.1'

